/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const ResponsesGroupBy = {
  UserId: "user_id",
  ApiKeyId: "api_key_id",
  OrgId: "org_id",
  Model: "model",
  Background: "background",
} as const;
export type ResponsesGroupBy = ClosedEnum<typeof ResponsesGroupBy>;

/** @internal */
export const ResponsesGroupBy$inboundSchema: z.ZodNativeEnum<
  typeof ResponsesGroupBy
> = z.nativeEnum(ResponsesGroupBy);
/** @internal */
export const ResponsesGroupBy$outboundSchema: z.ZodNativeEnum<
  typeof ResponsesGroupBy
> = ResponsesGroupBy$inboundSchema;
